import { render } from "./MyToast.vue?vue&type=template&id=07f3d1e9&scoped=true"
import script from "./MyToast.vue?vue&type=script&lang=js"
export * from "./MyToast.vue?vue&type=script&lang=js"

import "./MyToast.vue?vue&type=style&index=0&id=07f3d1e9&scoped=true&lang=css"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f3d1e9"]])

export default __exports__